import { AxiosError } from 'axios'
import { ElMessage } from 'element-plus'

import EventBus, { GlobalEvents } from '@shared/event-bus'
import i18n from '@shared/i18n'
import { HttpStatus } from '@shared/models/enums/http'
import {
  apiErrorCodeHandler,
  attemptRefreshToken,
} from '@shared/utils/helpers/errors/api-error-code-handler'

import { ApiErrorResponse } from '@protots/response/api_error_response'

import type { JsonValue } from '@protobuf-ts/runtime'

export const errorInterceptor = (error: AxiosError) => {
  if (error.code === AxiosError.ERR_CANCELED) {
    throw error
  }

  switch (error.response?.status) {
    case HttpStatus.UNAUTHORIZED:
      if (attemptRefreshToken(error?.response?.status)) {
        EventBus.emit(GlobalEvents.UnAuthenticated)
      }
      throw error
      break

    case HttpStatus.BAD_REQUEST:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.badRequestError'),
      })
      throw error
      break

    case HttpStatus.FORBIDDEN:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.forbiddenError'),
      })
      throw error
      break

    case HttpStatus.NOT_FOUND:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.errorNotFound'),
      })
      throw error
      break
    case HttpStatus.UNSUPPORTED_MEDIA_TYPE:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.mediaError'),
      })
      throw error
      break
    case HttpStatus.TOO_MANY_REQUESTS:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.tooManyRequestsError'),
      })
      throw error
      break

    case HttpStatus.UNPROCESSABLE_ENTITY:
      {
        const { errors } = ApiErrorResponse.fromJson(
          error.response?.data as JsonValue
        )
        // eslint-disable-next-line
        console.error(
          '[Vue 3 application] request error:',
          HttpStatus.UNPROCESSABLE_ENTITY
        )

        errors.forEach((item) => {
          if (item.type.oneofKind === 'error') {
            const { key, message, code } = item.type.error
            // eslint-disable-next-line
            console.table({ key, message, code })

            apiErrorCodeHandler(code)
          } else if (item.type.oneofKind === 'genericError') {
            const { message } = item.type.genericError
            // eslint-disable-next-line
            console.error('Error message:', message)
          }
        })
        throw error
      }
      break
    case HttpStatus.INTERNAL_SERVER_ERROR:
      // eslint-disable-next-line
      console.error('[Vue 3 application] API request error:')
      // eslint-disable-next-line
      console.dir(error)

      ElMessage({
        type: 'error',
        message: i18n.global.t('common.internalServerError'),
      })
      throw error
      break
    case HttpStatus.BAD_GATEWAY:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.badGatewayError'),
      })
      throw error
      break
    case HttpStatus.SERVICE_UNAVAILABLE:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.unavailableServiceError'),
      })
      throw error
      break
    case HttpStatus.GATEWAY_TIMEOUT:
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.timeoutGatewayError'),
      })
      throw error
      break

    default:
      // eslint-disable-next-line
      console.error('[Vue 3 application] API request error:', error)
      ElMessage({
        type: 'error',
        message: i18n.global.t('common.defaultError'),
      })
      throw error
      break
  }
}
